import { route } from 'preact-router';
import type { Connection } from '../../../types';
import { connectionManagementService } from '../../../services/connections/connection-management.service';
import { useScopeContext } from '../../../contexts/ScopeContext';
import { toast } from '../../../services/toast.service';

interface InfoTabProps {
  connection: Connection;
  onConnectionUpdate: () => void;
}

export function InfoTab({ connection, onConnectionUpdate: _onConnectionUpdate }: InfoTabProps) {
  const scope = useScopeContext();

  const handleDeleteConnection = async () => {
    // TODO: Replace with proper confirmation dialog
    if (!confirm('Are you sure you want to delete this connection? This action cannot be undone.')) return;

    try {
      await connectionManagementService.deleteConnection(scope.teamId, connection.connectionId || connection.id);
      toast.success('Connection deleted successfully');
      route(`${scope.getNavigationPrefix()}/connections`);
    } catch (err) {
      toast.error(`Failed to delete: ${err instanceof Error ? err.message : 'Unknown error'}`);
    }
  };

  return (
    <div className="space-y-4">
      <div className="card bg-base-100">
        <div className="card-body">
          <h3 className="card-title">Connection Information</h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="font-medium">Connection ID:</span>
              <span className="ml-2">{connection?.connectionId}</span>
            </div>
            <div>
              <span className="font-medium">Connector:</span>
              <span className="ml-2">{connection?.connectorId}</span>
            </div>
            <div>
              <span className="font-medium">Status:</span>
              <span className="ml-2">
                <span className={`badge badge-sm ${
                  connection?.hasCredentials ? 'badge-success' : 'badge-warning'
                }`}>
                  {connection?.hasCredentials ? 'configured' : 'not_configured'}
                </span>
              </span>
            </div>
            <div>
              <span className="font-medium">Activated:</span>
              <span className="ml-2">
                {connection?.active ? (
                  <span className="badge badge-success badge-sm">Yes</span>
                ) : (
                  <span className="badge badge-ghost badge-sm">No</span>
                )}
              </span>
            </div>
            <div>
              <span className="font-medium">Created:</span>
              <span className="ml-2">{connection?.createdAt ? new Date(connection.createdAt).toLocaleString() : 'N/A'}</span>
            </div>
            <div>
              <span className="font-medium">Updated:</span>
              <span className="ml-2">{connection?.updatedAt ? new Date(connection.updatedAt).toLocaleString() : 'N/A'}</span>
            </div>
            <div>
              <span className="font-medium">Created By:</span>
              <span className="ml-2">{connection?.createdBy || 'N/A'}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="card bg-base-100 border-error">
        <div className="card-body">
          <h3 className="card-title text-error">Danger Zone</h3>
          <p className="text-sm opacity-70">Once you delete a connection, there is no going back. Please be certain.</p>
          <div className="card-actions justify-end">
            <button className="btn btn-error" onClick={handleDeleteConnection}>
              Delete Connection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
